import { useEffect, useState } from "react";
import {
	Button,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Stack
} from "@chakra-ui/react";
import { SubmitHandler, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { RiMap2Line, RiPhoneLine, RiProfileLine, RiUser3Line } from "react-icons/ri";
import { useHistory } from 'react-router-dom';

import api from "../../services/api";
import { useCart } from "../../hooks/cart";
import { Input } from "../Inputs/Input";

/* let validate = {
	nome: '',
	doc: '',
	tel: '',
	cid: '',
}; */

type ValidateConsumidorData ={
	nome: string;
	doc: string;
	tel: string;
	cid: string;
}
type ConsumidorFormData = {
	// id: string;
	nome: string | undefined;
	doc: string | undefined;
	phone: string | undefined;
	cid: string | undefined;
}
type ConsumidorData = {
  id: string;
  nome: string;
  doc: string;
  phone: string;
  cid: string;
}
interface ModalConsumidorProps {
	isOpen: boolean;
	onRequestClose: (close: boolean) => void;
}

const ModalConsumidor: React.FC<ModalConsumidorProps> = ({
	isOpen,
	onRequestClose,
}) => {
	const [validate, setValidate] = useState<ValidateConsumidorData>({} as ValidateConsumidorData);

  const consumidorFormSchema: yup.SchemaOf<ConsumidorFormData> = yup.object().shape({
		...(validate.nome === 'S' ? {
			nome: yup.string().required('Nome é obrigatório.'),
		} : {
			nome: yup.string(),
		}),
		...(validate.doc === 'S' ? {
			doc: yup.string().required('Documento é obrigatório.'),
		} : {
			doc: yup.string(),
		}),
		...(validate.tel === 'S' ? {
			phone: yup.string().required('Telefone é obrigatório.'),
		} : {
			phone: yup.string(),
		}),
		...(validate.cid === 'S' ? {
			cid: yup.string().required('Cidade é obrigatório.'),
		} : {
			cid: yup.string(),
		}),
	});

	const { register, handleSubmit, formState, setValue, reset } = useForm<ConsumidorFormData>({
		resolver: yupResolver(consumidorFormSchema)
	});

	const { addCartCliente } = useCart();
	const history = useHistory();

	useEffect(() => {
		api.get('controle/client/consumidor')
			.then(response => {
				setValidate(response.data);
			})
	}, []);

	function handleMaskPhone(event: string) {
		let res = event;
		res = res.replace(/\D/g, '');
		res = res.replace(/^(\d{2})(\d)/g, '($1) $2');
		res = res.replace(/(\d)(\d{4})$/, '$1-$2');
		setValue('phone', res);
	}
	function handleMaskDoc(event: string) {
		let res = event.replace(/\D+/g, '');
		if (res.length <= 14) {
			res = res.replace(/(\d{3})(\d)/, "$1.$2");
			res = res.replace(/(\d{3})(\d)/, "$1.$2");
			res = res.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
			setValue('doc', res);
		}
		if (res.length > 14) {
			res = res.replace(/\D+/g, '');
			res = res.replace(/^(\d{2})(\d)/, "$1.$2")
			res = res.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
			res = res.replace(/\.(\d{3})(\d)/, ".$1/$2")
			res = res.replace(/(\d{4})(\d)/, "$1-$2")
			// res = res.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
			setValue('doc', res);
		}
	}

	const handleSubmitConsumidor: SubmitHandler<ConsumidorFormData> = (data: ConsumidorFormData) => {
		const consumidor = { ...data, id: '0' } as ConsumidorData;//, nome: data.nome.toLowerCase() };

		addCartCliente(consumidor, true);

		reset();
		onRequestClose(false);
		history.push('/products');
	}

	return (
		<Modal
			isCentered={true}
			closeOnOverlayClick={false}
			blockScrollOnMount={false}
			size="lg"
			isOpen={isOpen}
			onClose={() => onRequestClose(false)}
		>
			<ModalOverlay />

			<ModalContent as="form" onSubmit={handleSubmit(handleSubmitConsumidor)}>
				<ModalHeader>Consumidor</ModalHeader>

				<ModalCloseButton />

				<ModalBody>
					<Stack>
						<Input
							label="Nome"
							iconLabel={RiUser3Line}
							textTransform="capitalize"
							{...register("nome")}
							error={formState.errors.nome}
						 />

						<Input
							label="Documento"
              iconLabel={RiProfileLine}
							maxLength={18}
							{...register("doc")}
							error={formState.errors.doc}
              onChange={(e: any) => handleMaskDoc(e.target.value)}
						/>

						<Input
							label="Telefone"
              iconLabel={RiPhoneLine}
							maxLength={15}
							{...register("phone")}
							error={formState.errors.phone}
							onChange={e => handleMaskPhone(e.target.value)}
						/>

						<Input
							label="Cidade"
              iconLabel={RiMap2Line}
							textTransform="capitalize"
							{...register("cid")}
							error={formState.errors.cid}
						/>
					</Stack>
				</ModalBody>

				<ModalFooter>
					<Button colorScheme='blue' mr={3} type="submit">
						Salvar
					</Button>
					<Button
						variant='ghost'
						onClick={() => {
							reset();
							onRequestClose(false);
						}}
					>
						Cancelar
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	)
}

export default ModalConsumidor;
